import React, { useState, useRef, useEffect } from 'react';
import './FeaturedCategories.css';
import api from '../../api/axios.js'
import { API_IMAGE_BASE_URL } from '../../config/api';

const FeaturedCategories = () => {
  const dropdownRef = useRef(null);
  const fileInputRef = useRef(null);
  const modalRef = useRef(null);
  
  const [featuredCategories, setFeaturedCategories] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false)
  const [initialCategory, setInitialCategory] = useState(null);


  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);


   const [editingItem, setEditingItem] = useState(null)

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryQuery, setCategoryQuery] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [description, setDescription] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

   const [page, setPage] = useState(1); 
  const limit = 10;

  const fetchFeaturedCategories = async () => {
  try {
    const res = await api.get(
      `/featured-categories?search=${searchQuery}&page=${page}&limit=${limit}`
    );
    setFeaturedCategories(res.data?.data || []);
  } catch (err) {
    console.error('Failed to fetch featured categories', err);
  }
};

  const fetchCategories = async () => {
  try {
    const res = await api.get(`/categories?page=1&limit=500`);
    console.log("Categories API Response:", res.data);
console.log("Categories Count:", res.data?.data?.length);
    if (res.data?.success && Array.isArray(res.data.data)) {
      setAvailableCategories(res.data.data);
    }
  } catch (err) {
    console.error("Failed to fetch categories:", err);
  }
};
  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchFeaturedCategories();
  }, [searchQuery, page]);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setShowDropdown(false);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);


  useEffect(() => {
  const handleOutsideClick = (e) => {
    if (
      showAddModal &&
      modalRef.current &&
      !modalRef.current.contains(e.target)
    ) {
      resetForm();
    }
  };

  document.addEventListener("mousedown", handleOutsideClick);
  return () => {
    document.removeEventListener("mousedown", handleOutsideClick);
  };
}, [showAddModal]);

  const getFilteredCategories = () => {
    if (!categoryQuery.trim()) {
      return availableCategories;
    }
    return availableCategories.filter(category => 
      category.name.toLowerCase().includes(categoryQuery.toLowerCase())
    );
  };

  const selectCategory = (category) => {
    setSelectedCategory(category);
    setCategoryQuery(category.name);
    setShowDropdown(false);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

   const addFeaturedCategory = async () => {
    if (!editingItem) {
    if (!selectedCategory || !description.trim() || !selectedImage) return;
  } else {
    if (
      !selectedCategory &&
      !description.trim() &&
      !selectedImage
    ) return;
  }

    try {
      const fd = new FormData();
      if (selectedCategory) fd.append('category', selectedCategory._id);
    if (description.trim()) fd.append('description', description.trim());
    if (selectedImage) fd.append('image', selectedImage);
    console.log(description,"fd")

      if (editingItem) {
        console.log(editingItem,"ei")
        await api.put(`/admin/featured-categories/${editingItem._id}`, fd);
      } else {
        await api.post('/admin/featured-categories', fd);
      }

      resetForm();
      fetchFeaturedCategories();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || 'Failed to add category');
    }
  }

  const closeDropdown = () => {
  setShowDropdown(false);

  if (editingItem && !selectedCategory && initialCategory) {
    setSelectedCategory(initialCategory);
    setCategoryQuery(initialCategory.name);
  }
};


  const resetForm = () => {
    setShowAddModal(false);
    setEditingItem(null);
    setSelectedCategory(null);
    setCategoryQuery('');
    setDescription('');
    setSelectedImage(null);
    setImagePreview(null);
    setShowDropdown(false);
  }

  // const handleEdit = (item) => {
  //   setEditingItem(item); 
  //   setShowAddModal(true);
  //   setSelectedCategory(item.category);
  //   setCategoryQuery(item.category.name);
  //   setDescription(item.description);
  //   setImagePreview(item.image);
  // };

  const handleEdit = (item) => {
    setEditingItem(item); 
    setShowAddModal(true);

    setSelectedCategory(item.category);
     setInitialCategory(item.category);
    setCategoryQuery(item.category.name);
    setDescription(item.description);

    setImagePreview(`${API_IMAGE_BASE_URL}${item.image}`);
    setSelectedImage(null);
  };

 
  const deleteFeaturedCategory = async () => {
  try {
    await api.delete(`/admin/featured-categories/${deleteItem._id}`);
    fetchFeaturedCategories();
  } catch (err) {
    console.error(err);
  } finally {
    setDeleteItem(null);
    setShowDeleteModal(false);
  }
};


 const isFormValid =
    selectedCategory &&
    description.trim() &&
    (editingItem || selectedImage);


  return (
    <div className="featured-categories">
      <div className="page-header">
        <h1>Featured Categories</h1>
        <p>Manage featured categories for your platform</p>
      </div>

      <div className="categories-controls">
        <div className="search-container">
          <input
            type="text"
            placeholder="Search categories..."
            value={searchQuery}
             onChange={(e) => {
              setSearchQuery(e.target.value)
              setPage(1);
            }}
            className="search-input"
          />
        </div>
        <button 
          className="add-category-btn"
          onClick={() => setShowAddModal(true)}
        >
          + Add Featured Category
        </button>
      </div>

      <div className="categories-grid">
        {featuredCategories?.map(category => (
          <div key={category._id} className="category-card">
            <div className="category-image">
              <img src={`${API_IMAGE_BASE_URL}${category.image}`} alt={category.category.name} />
            </div>
            <div className="category-info">
              <h3>{category.category.name}</h3>
              <p>{category.description}</p>
            </div>
           <div className="card-actions">
              <button className="btn-edit" onClick={() => handleEdit(category)}>
                Edit
              </button>
              <button
                className="btn-delete"
                onClick={() => {
                  setDeleteItem(category);
                  setShowDeleteModal(true);
                }}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {featuredCategories.length === 0 && (
        <div className="no-categories">
          <p>{searchQuery ? 'No categories found matching your search.' : 'No featured categories added yet.'}</p>
        </div>
      )}

      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal" ref={modalRef}>
            <div className="modal-header">
              <h2>{editingItem ? 'Edit Featured Category' : 'Add Featured Category'}</h2>
              <button className="close-btn" onClick={resetForm}>×</button>
            </div>
            
            <div className="modal-body">
              <div className="form-group">
                <label>Category *</label>
                <div className="dropdown-container" ref={dropdownRef}>
                  <div className="input-with-icon">
                    <input
                      type="text"
                      placeholder="Search and select category..."
                      value={categoryQuery}
                      onChange={(e) => {
                        setCategoryQuery(e.target.value);
                        setSelectedCategory(null);
                        setShowDropdown(true);
                      }}

                      onFocus={() => {
                        setShowDropdown(true);
                        setCategoryQuery('');
                      }}
                     

                      className="category-search-input"
                    />
                
                    {/* <span 
  className={`dropdown-icon ${showDropdown ? 'open' : ''}`}
  onClick={(e) => {
    e.stopPropagation();

    if (showDropdown) {
      setShowDropdown(false);

      if (!selectedCategory && editingItem && initialCategory) {
        setSelectedCategory(initialCategory);
        setCategoryQuery(initialCategory.name);
      }
    } else {
      setShowDropdown(true);
      setCategoryQuery('');
    }
  }}
>
  ▼
</span> */}
<span 
  className={`dropdown-icon ${showDropdown ? 'open' : ''}`}
  onClick={(e) => {
    e.stopPropagation();
    if (showDropdown) {
      closeDropdown();
    } else {
      setShowDropdown(true);
      setCategoryQuery('');
    }
  }}
>
  ▼
</span>

                  </div>
                  
                  {showDropdown && (
                    <div className="dropdown-results">
                      {getFilteredCategories().map(category => (
                        <div 
                          key={category._id} 
                          className="dropdown-item" 
                          onClick={() => selectCategory(category)}
                        >
                          {category.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label>Image *</label>
                <div className="image-upload" onClick={() => fileInputRef.current?.click()}>
                  {imagePreview ? (
                    <img src={imagePreview} alt="Preview" className="image-preview" />
                  ) : (
                    <div className="upload-placeholder">
                      <span className="upload-icon">+</span>
                      <span>Click to upload image</span>
                    </div>
                  )}
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Description *</label>
                <textarea
                  placeholder="Enter category description..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="description-textarea"
                  rows="4"
                />
              </div>
            </div>
            
            <div className="modal-footer">
              <button className="btn-cancel" onClick={resetForm}>Cancel</button>
              <button 
                onClick={addFeaturedCategory}
                disabled={!isFormValid}
                className="btn-save"
              >
                {editingItem ? 'Update' : 'Add'}
              </button>
            </div>
          </div>
        </div>
      )}
      {showDeleteModal && deleteItem && (
  <div
    className="modal-overlay"
    onClick={(e) => {
      if (e.target.classList.contains("modal-overlay")) {
        setShowDeleteModal(false);
        setDeleteItem(null);
      }
    }}
  >
    <div className="modal delete-modal">
      <h3>Delete Confirmation</h3>
      <p>
        Are you sure you want to delete
        <strong> {deleteItem.category.name}</strong>?
      </p>

      <div className="delete-modal-footer">
        <button
          className="btn-cancel"
          onClick={() => {
            setShowDeleteModal(false);
            setDeleteItem(null);
          }}
        >
          Cancel
        </button>

        <button className="btn-delete" onClick={deleteFeaturedCategory}>
          Delete
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default FeaturedCategories;